import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SvgPrimaryLinkCircle = function SvgPrimaryLinkCircle(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: "48",
      height: "48",
      rx: "24",
      fill: "none"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.5303 18.4697C26.2374 18.1768 25.7626 18.1768 25.4697 18.4697C25.1768 18.7626 25.1768 19.2374 25.4697 19.5303L29.2381 23.2987L17 23.25C16.5858 23.25 16.25 23.5858 16.25 24C16.25 24.4142 16.5858 24.75 17 24.75H29.1893L25.4697 28.4697C25.1768 28.7626 25.1768 29.2374 25.4697 29.5303C25.7626 29.8232 26.2374 29.8232 26.5303 29.5303L31.5303 24.5303C31.6022 24.4584 31.6565 24.3755 31.6931 24.2871M31.6928 23.7121C31.6562 23.624 31.602 23.5414 31.5303 23.4697L26.5303 18.4697M31.6932 24.2868C31.7298 24.1984 31.75 24.1016 31.75 24C31.75 23.898 31.7296 23.8008 31.6928 23.7121",
      fill: "white"
    })]
  }));
};